<template>
  <div ref="card">
    <form action>
      <div id="card" class="form-control mb-4"></div>
      <button class="btn btn-primary">Update</button>
    </form>
  </div>
</template>

<script>
export default {
  props: ["user"],
  data() {
    return {};
  },
  methods: {
    setUpStripe() {
      let options = {
        style: {
          base: {
            color: "#424770",
            letterSpacing: "0.025em",
            fontFamily: "Source Code Pro, monospace",
            "::placeholder": {
              color: "#aab7c4"
            }
          },
          invalid: {
            color: "#9e2146"
          }
        },
        hidePostalCode: true
      };

      if (window.Stripe === undefined) {
        console.error("Stripe V3 library not loaded!");
      } else {
        const stripe = window.Stripe(process.env.MIX_STRIPE_KEY);
        this.stripe = stripe;

        const elements = stripe.elements();
        this.card = elements.create("card", options);
        this.card.mount("#card");

        this.listenForErrors();
      }
    },
    listenForErrors() {
      this.card.addEventListener("change", event => {
        if (event.error) {
          this.errors.stripe = [event.error.message];
        } else {
          delete this.errors.stripe;
        }
      });
    }
  },
  mounted() {
    this.setUpStripe();
  }
};
</script>